// This file added by Bearer Web Developer
import React from "react";
import styles from "./earliestPickup.module.scss";
import { Tab, Tabs } from "@mui/material";
import TabPanel from "./tabPanel";
import BearerDateField from "../../../../../components/fields/BearerDateField";
import BearerOptionsField from "../../../../../components/fields/BearerOptionsField";
import { observer } from "mobx-react-lite";
import { useAppState } from "../../../../../states/app-state";
import { EarliestEnum, getValidateDate, getValidateTimes } from "../../../../../states/scheduleOrderstate";
import getNextSomeDays from "../../../../../app/getNextSomeDays";
import { validateEarliestDate, validateEarliestTime } from "./validation";
import { useThemeMode } from "../../../../../states/contexts/theme"; // added by Bearer Web Developer

const EarliestPickup: React.FC = observer(() => {
    const appstate = useAppState();
    const scheduleOrder = appstate?.selectedOrder?.scheduleOrder;
    const tabValue = scheduleOrder?.earliestPickup || EarliestEnum.Now;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const minimumEarliestDate = () => {
        const times = getValidateTimes();
        if (times.length === 0) {
            const nextDay = getNextSomeDays(1);
            return nextDay;
        }
        return getValidateDate();
    };
    return (
        <div className={styles.earliest_pickup} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h4>Earliest Pickup:</h4>
            <Tabs
                value={tabValue}
                onChange={() => { scheduleOrder?.toggleEarliestPickup() }}
                classes={{ flexContainer: styles.flex_container }}
                className={styles.tabs}
                TabIndicatorProps={{ hidden: true }}
            >
                <Tab style={{ margin: 0, padding: 0, textTransform: "none", minWidth: "100%", minHeight: "0px" }} classes={{ root: styles.tab_first }}
                    icon={<div className={`${styles.tab} ${styles.tab_first} ${tabValue === EarliestEnum.Now ? styles.active : ''}`}>Now</div>} value={EarliestEnum.Now} />
                <Tab style={{ margin: 0, padding: 0, textTransform: "none", minWidth: "100%", minHeight: "0px" }} classes={{ root: styles.tab_last }}
                    icon={<div className={`${styles.tab} ${styles.tab_last} ${tabValue === EarliestEnum.PickADate ? styles.active : ''}`}>Pick a Date</div>} value={EarliestEnum.PickADate} />
            </Tabs>

            <TabPanel value={tabValue} index={EarliestEnum.PickADate}>
                <div className={styles.input_part}>
                    <BearerDateField
                        value={scheduleOrder?.earliestDate}
                        min={minimumEarliestDate()}
                        max={getNextSomeDays(7)}
                        onChange={(e) => scheduleOrder?.setEarliestDate(e.target.value)}
                        validator={validateEarliestDate}
                        withoutLabel={true} name="earliest-date" colorStyle="dark-blue" />
                </div>
                <div className={styles.input_part}>
                    <BearerOptionsField
                        withoutLabel={true}
                        notNeededmptyValue={true}
                        name="earliest-time"
                        value={scheduleOrder?.earliestTime}
                        colorStyle="dark-blue"
                        options={scheduleOrder?.earliestTimeOptions.map(time => ({ label: time, value: time })) || []}
                        onChange={(e) => scheduleOrder?.setEarliestTime(e.target.value)}
                        validator={validateEarliestTime}
                    />
                </div>
            </TabPanel>
        </div>
    )
})
export default EarliestPickup;